import './ItemCard.css'

function ItemCard(props) {
    return (
        <div className='item-card-main' onClick={() => props.onSelect(props.name) }>
            <h5 className='item-card-name'>{props.name}</h5>
            <h5>${props.price.toFixed(2)}</h5>
            {
                props.mealprice ? <h5>(${props.mealprice.toFixed(2)})</h5> : null
            }
        </div>
    )
}

export default ItemCard;